import { styled } from "@stitches/react";
import { useState, useEffect } from "react";
import { DateInput, DateInputOnChangeEvent, Button } from "@/vendor/Forge/dist";
import { useOrdersContext } from "@/contexts/orders-context";

const PerfDateFilterWrapper = styled("div", {
    display: "flex",
    flexDirection: "column",
  });

const DateInputWrapper = styled("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",
    marginBottom: "25px",
    marginTop: "10px",

    "& p": {
      textAlign: "center",
      marginBottom: "0px",
    }
});

const ButtonsWrapper = styled("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",

    "& .fe_c_button": {
        width: "35%",
    }
});

const PerfDateFilter = () => {
    const [perfDateStart, setPerfDateStart] = useState<Date>();
    const [perfDateEnd, setPerfDateEnd] = useState<Date>();
    const [isConfirmDisabled, setIsConfirmDisabled] = useState<boolean>();
    const { updateMultipleFilters, filters } = useOrdersContext();

    useEffect(() => {
        if (filters.performDateRangeStar && filters.performDateRangeEn) {
            if (filters.performDateRangeStar[0] !== "" && filters.performDateRangeEn[0] !== "") {
               setPerfDateStart(new Date(filters.performDateRangeStar[0]));
               setPerfDateEnd(new Date(filters.performDateRangeEn[0]));
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (perfDateStart !== undefined && perfDateEnd === undefined) {
            setPerfDateEnd(perfDateStart);
        }
        if (perfDateEnd !== undefined && perfDateStart === undefined) {
            setPerfDateStart(perfDateEnd);
        }
    }, [perfDateStart, perfDateEnd]);

    useEffect(() => {
        if (perfDateStart === undefined || perfDateEnd === undefined) {
            setIsConfirmDisabled(true);
        } else {
            setIsConfirmDisabled(false);
        }
    }, [perfDateStart, perfDateEnd]);

    const handleFilterClick = () => {
        updateMultipleFilters({
            performDateRangeStar: [
                    (perfDateStart ?? new Date()).toLocaleDateString(
                    'en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }
                )
            ],
            performDateRangeEn: [
                (perfDateEnd ?? new Date()).toLocaleDateString(
                'en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }
            )
        ],
        });
        setPerfDateStart(undefined);
        setPerfDateEnd(undefined);
        const closeButton = document.querySelector('button[aria-label="Close Modal"]');
        if (closeButton) closeButton.id = 'closeModal';
        const modalClose = document.getElementById('closeModal');
        if (modalClose) modalClose.click();
    };

    const handleClearDates = () => {
        updateMultipleFilters({
            performDateRangeStar: [""],
            performDateRangeEn: [""],
        });
        setPerfDateStart(undefined);
        setPerfDateEnd(undefined);
        const closeButton = document.querySelector('button[aria-label="Close Modal"]');
        if (closeButton) closeButton.id = 'closeModal';
        const modalClose = document.getElementById('closeModal');
        if (modalClose) modalClose.click();
    };

    return (
        <PerfDateFilterWrapper>
        <DateInputWrapper>
            <DateInput
                defaultValue={
                    filters.performDateRangeStar ? (
                            filters.performDateRangeStar[0] != "" ?
                            new Date(filters.performDateRangeStar[0]) :
                            undefined
                    ) : undefined
                }
                value={perfDateStart}
                onChange={
                    (e: DateInputOnChangeEvent) => {
                        setPerfDateStart(
                            new Date(
                                e.target.value ?? new Date
                            ));
                    }
                }
            />
            <p>to</p>
            <DateInput
                defaultValue={
                    filters.performDateRangeEn ? (
                            filters.performDateRangeEn[0] != "" ?
                            new Date(filters.performDateRangeEn[0]) :
                            undefined
                    ) : undefined
                }
                value={perfDateEnd}
                onChange={
                    (e: DateInputOnChangeEvent) => {
                        setPerfDateEnd(
                            new Date(
                                e.target.value ?? new Date
                            )
                        );
                    }
                }
            />
        </DateInputWrapper>
        <ButtonsWrapper>
            <Button
                variant="secondary"
                onClick={handleClearDates}
            >
                Clear Dates
            </Button>
            <Button
                disabled={isConfirmDisabled}
                onClick={handleFilterClick}
            >
                Filter Dates
            </Button>
        </ButtonsWrapper>
        </PerfDateFilterWrapper>
    );
};

export default PerfDateFilter;
